import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import processesReducer from './slices/processSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    processes: processesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
